<div class="list-wrapper">
  <kgrid
    *ngIf="filterInfo && filterInfo.length"
    [apiName]="apiName"
    [areaName]="areaName"
    [label]="label"
    [name]="apiName"
    [VoucherKindIdName]="'TrsVoucherKindId'"
    [isModal]="false"
    [isMulti]="true"
    [isMultiDelete]="true"
    reportName="TresuryList"
    [filters]="filters"
    pathPreFix="TRS"
    [defaultFilterKey]="filterInfo"
    [actions]="actions"
    [actionTregger]="onActionClick"
    [isAdd]="false"
    [inputEditorform]="inputEditorform">
  </kgrid>
</div>
